import { dateFromTimeStamp, timeFromTimeStamp } from '../shared/utilities';

export default ({ cell }) => {
  const created = cell.getValue();
  return `${dateFromTimeStamp(created)}`;
};
